import React from 'react';
import { css, keyframes } from '@emotion/css';
import { css as globalCss, Global } from '@emotion/react';
import { withBasicStyles } from '@/styles/common';

const primaryBlue = '#0078FF'; // 主蓝色
const lightBlue = '#E6F0FF';   // 浅蓝色气泡背景
const darkGray = '#333';        // 深灰色文本
const lightGray = '#888';       // 浅灰文本
const borderGray = '#ddd';      // 边框灰色

const slideInRight = keyframes`
  from { transform: translateX(-100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

const slideOutRight = keyframes`
  from { transform: translateX(0); opacity: 1; }
  to { transform: translateX(-100%); opacity: 0; }
`;

export const useStyles = withBasicStyles(() => ({
  // 静态样式
  conversationsWrapper: css`
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
  `,

  capWrapper: css`
    padding: 12px 16px;
    display: flex;
    align-items: center;
  `,

  capShape: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 40px;
    margin-left: 16px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px 0px rgba(127,135,166,0.08);
    border-radius: 24px;
    border: 1px solid #E7E7E7;
    box-sizing: border-box;
    transition: box-shadow 0.2s, border-color 0.2s;
    cursor: pointer;
    /* &:hover {
      box-shadow: 0px 4px 24px 0px rgba(127,135,166,0.16);
      border-color: ${primaryBlue};
    } */
  `,

  capIcon: css`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      width: 17px;
    }

    &:hover {
      background: #F2F2F2;
      border-radius: 50%;
    }
  `,

  addChatBtn: css`
    width: 256px;
    height: 40px;
    margin: 17px auto 24px;
    background: #FFFFFF;
    border-radius: 20px;
    border: 1px solid #E7E7E7;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #343434;

    &:hover {
      color: #3961F2;
    }

    &:active {
      color: #0A3BEE;
    }
  `,

  tipTitle: css`
    font-size: 12px;
    color: #949494;
    padding-left: 24px;
  `,

  fWrapper: css`
    background: #F8FBFF;
    padding: 16px 0 13px;
    width: 280px;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-shrink: 0;
    border-right: 1px solid #f0f0f0;
  `,

  nWrapper: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 280px;
    height: 100%;
    box-sizing: border-box;
    z-index: 1000;
    transition: left 0.3s ease;
    background: #F8FBFF;
    padding: 16px 0 13px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  `,

  mask: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.15);
    z-index: 999;
    cursor: pointer;
  `,

  fheaderWrapper: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 11px 0 16px;
  `,

  scrollList: css`
    /* 使用侧栏的真实剩余高度，兼容全屏、弹窗及任意高度的嵌入容器。 */
    flex: 1;
    min-height: 0;
    padding-bottom: 15px;
    box-sizing: border-box;
    overflow-y: auto;

    /* 隐藏滚动条（Chrome, Edge, Safari） */
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
      background: transparent;
    }

    /* 隐藏滚动条（Firefox） */
    scrollbar-width: none;

    /* 隐藏滚动条（IE/Edge） */
    -ms-overflow-style: none;
  `,

  slideIn: css`
    animation: ${slideInRight} 0.3s forwards;
  `,
  slideOut: css`
    animation: ${slideOutRight} 0.3s forwards;
  `,

}));

export const GlobalStyle: React.FC = () => (
  <Global
    styles={globalCss`
      .ant-conversations .ant-conversations-item-active {
        background: rgba(57,97,242,0.08);
      }

      .ant-conversations .ant-conversations-item-active .ant-conversations-label {
        color: #3961F2;
      }
    `}
  />
);
